<template>
  <div class="flex items-center justify-center p-8">
    
    <!-- iPhone 外框（严格 285px × 617px） -->
    <div class="iphone-frame">
      <div class="iphone-screen flex flex-col">
        
        <!-- 状态栏 -->
        <div class="status-bar flex items-center justify-between px-6 pt-3 text-sm font-semibold text-black">
          <div>9:41</div>
          <div class="flex items-center gap-3">
            <!-- 信号强度 -->
            <div class="flex gap-[2px]" style="align-items: flex-end;">
              <div class="w-[3px] h-[4px] bg-black rounded-sm"></div>
              <div class="w-[3px] h-[7px] bg-black rounded-sm"></div>
              <div class="w-[3px] h-[10px] bg-black rounded-sm"></div>
              <div class="w-[3px] h-[13px] bg-black rounded-sm"></div>
            </div>
            <!-- WiFi -->
            <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.5 11.5C10.3284 11.5 11 10.8284 11 10C11 9.17157 10.3284 8.5 9.5 8.5C8.67157 8.5 8 9.17157 8 10C8 10.8284 8.67157 11.5 9.5 11.5Z" fill="#111"/>
              <path d="M3.5 8.5C3.5 8.5 6 5 9.5 5C13 5 15.5 8.5 15.5 8.5" stroke="#111" stroke-width="1.8" stroke-linecap="round"/>
              <path d="M1 5C1 5 5 1 9.5 1C14 1 18 5 18 5" stroke="#111" stroke-width="1.8" stroke-linecap="round"/>
            </svg>
            <!-- 电池 -->
            <div class="flex items-center gap-px">
              <div class="border border-black rounded-[3px] w-[22px] h-[10px] relative">
                <div class="absolute top-[1px] left-[1px] h-[6px] w-[16px] bg-black rounded-[1px]"></div>
              </div>
              <div class="w-[2px] h-[6px] bg-black rounded-r"></div>
            </div>
          </div>
        </div>
        
        <!-- 主屏幕空白区域 -->
        <div class="flex-1 " style="display: flex; text-align: center;justify-content: center; padding-top: 10px;">
          <div style="width:261px; height: 112px;" v-if="icon_src">
            <img :src="icon_src" width="261" height="112" style="border-radius: 10px;" />
          </div>
        </div>
        
        <!-- 底部 Tab Bar -->
        <div class="tab-bar bg-white  flex items-center justify-around h-[83px] relative">
          
          <!-- 首页（橙色激活） -->
          <div class="flex flex-col items-center justify-center gap-1 text-[#FF3B30]">
            <!-- Home 图标 -->
            <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2L2 12H5V21H9V16H15V21H19V12H22L12 2Z"/>
            </svg>
            <span class="text-[10px] font-medium tracking-wide">{{$I18n("home_page_02")}}</span>
          </div>
          
          <!-- 设置（灰色） -->
          <div class="flex flex-col items-center justify-center gap-1 text-[#8E8E93]">
            <!-- Sun 图标（与图片完全一致） -->
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="5" stroke="currentColor" stroke-width="2"/>
              <path d="M12 1V4" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              <path d="M12 20V23" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              <path d="M4.93 4.93L7.05 7.05" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              <path d="M16.95 16.95L19.07 19.07" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              <path d="M1 12H4" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              <path d="M20 12H23" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              <path d="M4.93 19.07L7.05 16.95" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              <path d="M16.95 7.05L19.07 4.93" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
            <span class="text-[10px] font-medium tracking-wide">{{$I18n("setting")}}</span>
          </div>
          
          <!-- 我的（灰色） -->
          <div class="flex flex-col items-center justify-center gap-1 text-[#8E8E93]">
            <!-- Person 图标 -->
            <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="8" r="4"/>
              <path d="M4 21C4 17.6863 7.13401 15 12 15C16.866 15 20 17.6863 20 21" fill="currentColor"/>
            </svg>
            <span class="text-[10px] font-medium tracking-wide">{{$I18n("my")}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name:'phone-two',
    props:['icon_src'],
    data(){
      return {

      }
    },
  }
</script>

<style scoped>
.iphone-frame {
  width: 285px;
  height: 617px;
  background: #ffffff;
  border-radius: 30px;
  box-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.4);
  position: relative;
  overflow: hidden;
  border: 2px solid #11111150;
}

.iphone-screen {
  width: 100%;
  height: 100%;
  background: #f8f9fa;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
}

.status-bar {
  height: 44px;
}

.tab-bar {
  box-shadow: 0 -1px 0 #c6c6c8;
}
img{
  width: 100%;
  height: 100%;
}
</style>